const BOOTSTRAP_LOADING_ID = 'th-bootstrap-loading'
const BOOTSTRAP_SPINNER_ID = 'th-bootstrap-spinner'

export function showBootstrapLoading() {
  if (document.getElementById(BOOTSTRAP_LOADING_ID)) return

  const loading = document.createElement('div')
  loading.id = BOOTSTRAP_LOADING_ID
  loading.setAttribute('role', 'status')
  loading.setAttribute('aria-live', 'polite')
  loading.setAttribute('aria-label', 'Loading...')

  const spinner = document.createElement('div')
  spinner.id = BOOTSTRAP_SPINNER_ID
  spinner.setAttribute('aria-hidden', 'true')
  loading.appendChild(spinner)

  document.body.appendChild(loading)
}

export function removeBootstrapLoading() {
  document.getElementById(BOOTSTRAP_LOADING_ID)?.remove()
}
